require('./openYoungCardAcceptMoneyRequestView.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
//@ Commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardChargeActions = require('actions/cardCharge');
const openYoungCardMoneyRequest = require('actions/openYoungCardMoneyRequest');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardCharge = require('components/cards/cardCharge/cardCharge');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardChargeSuccessStep = require('components/cards/cardChargeSteps/cardChargeSuccessStep/cardChargeSuccessStep');
const CardChargeErrorStep = require('components/cards/cardChargeSteps/cardChargeErrorStep/cardChargeErrorStep');
const CardChargeAccountFullStep = require('components/cards/cardChargeSteps/cardChargeAccountFullStep/cardChargeAccountFullStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');

// @constants
const {
    OPENYOUNG_MAX_BALANCE,
    GRAPHIC_TUTOR_TYPE_4,
    MONEY_REQUEST_VIEW ,
    ACCEPT_MONEY_REQUEST_STATUS
} = require('constants/index');

class OpenYoungCardAcceptMoneyRequestView extends React.Component {
    constructor(props) {
        super(props);
        this.postChange = this.postChange.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { cardId } }, requestECardInfo, immCards, immAccounts, openYoungCardMoneyRequest, setAccount, setAmount } = this.props;
        const amountRequested = openYoungCardMoneyRequest.getIn(['moneyRequestDetail', 'requestAmount']);
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_CHARGE, { immCard }, history);
        requestECardInfo(cardId);

        setAccount(immAccounts.getIn(['byOrder', 0]));
        setAmount(amountRequested);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    postChange() {
        const { match: { params: { cardId } }, postChange } = this.props;
        postChange(cardId, ACCEPT_MONEY_REQUEST_STATUS);
    }

    render() {
        const {
            match: { params: { cardId } },
            immCards,
            immCardCharge,
            validateStep,
            setVisibleStep,
            setWillCancel,
            immAccounts,
            requestECardInfo,
            openYoungCardMoneyRequest
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('moneyRequestView-acceptTitle')}
            />
        );
        const mappingBreadcrumb = [
            {
                text: formatText('moneyRequestView-acceptRequestBreadcrumb'),
                url: ''
            }
        ];

        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.getIn(['alias', 'current']);
        const moneyRequestDetails = openYoungCardMoneyRequest.get('moneyRequestDetail');
        const isFetching = moneyRequestDetails.get('isFetching');
        const accountMaxReached = (immCard.getIn(['availableBalance','amount']) === OPENYOUNG_MAX_BALANCE);
        let bodyContent;

        if (isFetching) {
            bodyContent = <LoadingSection />
        }
        if(accountMaxReached) {
            bodyContent = (
                <CardChargeAccountFullStep
                    immCard={immCard}
                    amount={openYoungCardMoneyRequest.getIn(['moneyRequestDetail', 'requestAmount'])}
                />
            )
        } else if (immCardCharge.get('submitSuccessful')) {
            bodyContent = (
                <CardChargeSuccessStep
                    immAccounts={immAccounts}
                    immCard={immCard}
                    immCardCharge={immCardCharge}
                    loading={immCardCharge.get('isFetching')}
                    requestEcardInfo={requestECardInfo}
                    view={MONEY_REQUEST_VIEW}
                />
            );
        } else if (immCardCharge.get('blockFlow')) {
            const messageObject = {
                title : 'moneyRequestView-acceptErrorMessage',
                goBackLink: 'myprofile/global'
            };
            bodyContent = <CardChargeErrorStep immCard={immCard} messageObject={messageObject} />;
        } else {
            bodyContent = (
                <div>
                    <div className="col-xs-12 col-md-8">
                        <CardCharge
                            immAccounts={immAccounts}
                            immCard={immCard}
                            immCardCharge={immCardCharge}
                            validateStep={validateStep}
                            setVisibleStep={setVisibleStep}
                            setWillCancel={setWillCancel}
                            postChange={this.postChange}
                            view={MONEY_REQUEST_VIEW}
                            moneyRequestDetails={moneyRequestDetails}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                        <CardDetailsSidebar immCard={immCard} />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="container-fluid card-charge-view--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('moneyRequestView-acceptTitle')}
                            >
                                <CardHeaderDetails
                                    immCard={immCard}
                                    isFetching={immCardCharge.get('isFetching')}
                                />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungCardAcceptMoneyRequestView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    openYoungCardMoneyRequest: PropTypes.object.isRequired,
    postChange: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestECardInfo: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setAmount: PropTypes.func,
    setAccount: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
}

module.exports.Constructor = OpenYoungCardAcceptMoneyRequestView;
module.exports.OpenYoungCardAcceptMoneyRequestView = connect(
    state => ({
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immAccounts: state.accounts,
        openYoungCardMoneyRequest: state.openYoungCardMoneyRequest
    }),
    {
        clearRequest: cardChargeActions.clearRequest,
        postChange: openYoungCardMoneyRequest.postChange,
        requestECardInfo: cardChargeActions.requestECardInfo,
        setVisibleStep: cardChargeActions.setVisibleStep,
        setWillCancel: cardChargeActions.setWillCancel,
        setAccount: cardChargeActions.setAccount,
        setAmount: cardChargeActions.setAmount,
        validateStep: cardChargeActions.validateStep

})(withRouter(OpenYoungCardAcceptMoneyRequestView));
